import { ImportCSVTableFieldModel } from "./ImportCSV";
import Style from 'ol/style/Style';
import VectorSource from 'ol/source/Vector';
import Icon from 'ol/style/Icon';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Text from 'ol/style/Text';
import { Circle } from 'ol/style';
import CircleStyle from 'ol/style/Circle';
import { Layer, VectorLayerDMTR } from "../menu/view-menu/layer";



export class ObstacleCsvModel {
  table : ImportCSVTableFieldModel[] = [];
  dataStartingLine : number = 2;
  fieldSeparator : string = ";";
  decimalSeparator : string = ",";
  file : File;
  fileContent : ObstacleCSVContent[] = [];
  layerName: string;
  fileName: string;
  visible: boolean = true;
  fillTable() : void {
    this.table.push(new ImportCSVTableFieldModel("Latitude","A"));
    this.table.push(new ImportCSVTableFieldModel("Longitude","B"));
    this.table.push(new ImportCSVTableFieldModel("Elevation","C"));
    this.table.push(new ImportCSVTableFieldModel("Type (0/1)","D"));
    this.table.push(new ImportCSVTableFieldModel("Text Note","E"));
  }

  saveData(): ObstacleCsvModel{
    let newModel : ObstacleCsvModel = new ObstacleCsvModel();
    newModel.dataStartingLine = this.dataStartingLine;
    newModel.fieldSeparator = this.fieldSeparator;
    newModel.decimalSeparator = this.decimalSeparator;
    return newModel;
  }
}

export class ObstacleCSVContent{

  latitude : string;
  longitude : string;
  elevation : string;
  type : string;
  textNote : string;

  height : string;

  static map(csvLine: any, table: ImportCSVTableFieldModel[]): ObstacleCSVContent {

    var line : ObstacleCSVContent = new ObstacleCSVContent();
    line.latitude = csvLine[ImportCSVTableFieldModel.convertLetterToNumber(ImportCSVTableFieldModel.getLetterFromTable("Latitude",table))];
    line.longitude = csvLine[ImportCSVTableFieldModel.convertLetterToNumber(ImportCSVTableFieldModel.getLetterFromTable("Longitude",table))];
    line.elevation = csvLine[ImportCSVTableFieldModel.convertLetterToNumber(ImportCSVTableFieldModel.getLetterFromTable("Elevation",table))];
    line.type = csvLine[ImportCSVTableFieldModel.convertLetterToNumber(ImportCSVTableFieldModel.getLetterFromTable("Type (0/1)",table))];
    line.textNote = csvLine[ImportCSVTableFieldModel.convertLetterToNumber(ImportCSVTableFieldModel.getLetterFromTable("Text Note",table))];
    return line;
  }
}

export class ObstacleLayer{
  static getNewLayers(): Layer[]{
    return [
      {id:'obstacleHuman', name:'Human Made', image:'cp1-gray.svg', visible:true, olLayer:new VectorLayerDMTR({
        source: new VectorSource(),
        style: [new Style({
          fill: new Fill({
            color: 'rgba(0, 0, 255, 1)',
          }),
          image: new CircleStyle({
            radius: 2,
            stroke: new Stroke({
              color: 'rgba(0, 0, 255, 1)',
            }),
            fill: new Fill({
              color: 'rgba(0, 0, 255, 1)',
            }),
          }),
        }),
        new Style({
          image: new Icon({
            scale: 0.04,
            src: "/assets/img/cp1.png",
          }),
        })],
        styleSelected: [new Style({
          fill: new Fill({
            color: 'rgba(0, 0, 255, 1)',
          }),
          image: new CircleStyle({
            radius: 2,
            stroke: new Stroke({
              color: 'rgba(0, 0, 255, 1)',
            }),
            fill: new Fill({
              color: 'rgba(0, 0, 255, 1)',
            }),
          }),
        }),
        new Style({
          image: new Icon({
            scale: 0.04,
            src: "/assets/img/cp1_BL.svg",
          }),
        })],
      })},
      {id:'obstacleNatural', name:'Natural', image:'cp1-gray.svg', visible:true, olLayer:new VectorLayerDMTR({
        source: new VectorSource(),
        style: [new Style({
          fill: new Fill({
            color: 'rgba(0, 255, 0, 1)',
          }),
          image: new CircleStyle({
            radius: 2,
            stroke: new Stroke({
              color: 'rgba(0, 255, 0, 1)',
            }),
            fill: new Fill({
              color: 'rgba(0, 255, 0, 1)',
            }),
          }),
        }),
        new Style({
          image: new Icon({
            scale: 0.04,
            src: "/assets/img/cp1.png",
          }),
        })],
        styleSelected: [new Style({
          fill: new Fill({
            color: 'rgba(0, 255, 0, 1)',
          }),
          image: new CircleStyle({
            radius: 2,
            stroke: new Stroke({
              color: 'rgba(0, 255, 0, 1)',
            }),
            fill: new Fill({
              color: 'rgba(0, 255, 0, 1)',
            }),
          }),
        }),
        new Style({
          image: new Icon({
            scale: 0.04,
            src: "/assets/img/cp1_BL.svg",
          }),
        })],
      })},
      {id:'obstacleUnknown', name:'Unknown', image:'cp1-gray.svg', visible:true, olLayer:new VectorLayerDMTR({
        source: new VectorSource(),
        style: new Style({
          image: new Icon({
            scale: 0.04,
            src: "/assets/img/cp1.png",
          }),
        }),
        styleSelected: new Style({
          image: new Icon({
            scale: 0.04,
            src: "/assets/img/cp1_BL.svg",
          }),
        }),
      })},
    ];
  }
}
